import {put,takeLatest,call} from 'redux-saga/effects';
import * as imageService from "../../../services/imageService";
import {
    GET_IMAGE,
    GET_IMAGE_SUCCESS,
    GET_IMAGE_ERROR
}
    from "../../actions/image";

function* getImageSaga(action) {
    try {
        const data=yield call(imageService.GetImage,action.payload)
        yield put({
            type: GET_IMAGE_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_IMAGE_ERROR,error: error.data
        });
    }
}

export function* getImageSagaWatcher() {
    yield takeLatest(GET_IMAGE,getImageSaga);
}